import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import SettingInformationEdit from '../polling/pollingTopicEdit/SettingInformationEdit';

export type SelectSettingInformationDialogProps = {
    isOpen: boolean;
    onOK: (data: any) => void;
    onCancel: () => void;
    data: any;
    dialogTitle: string;
};

export const SelectSettingInformationDialog = (props: SelectSettingInformationDialogProps) => {
    const { isOpen, onOK, onCancel, data, dialogTitle } = props;
    const [open, setOpen] = React.useState(isOpen);

    // Cancelボタンイベント
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };

    const handleUpdate = (data: any) => {
        setOpen(false);
        onOK(data);
    };

    return (
        <div>
            <Dialog open={open} maxWidth={"md"} fullWidth>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent sx={{ pb: 1.5 }}>
                    <SettingInformationEdit onCancel={handleCancel} settingInformation={data} onOK={(data) => handleUpdate(data)}></SettingInformationEdit>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default SelectSettingInformationDialog;